/**
 * B 層 AI 工程總控（Overseas patch 251）
 */
export const AI_ENGINEERING_CONTROL_MENU_IDS = {
  group: 990457,
  desk: 990458,
  view: 990459
}

export default AI_ENGINEERING_CONTROL_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/aiEngineeringControl.js